export default {"src":"/_next/static/media/place-pin.8440d362.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};